import $ from 'jquery'
import bindAll from 'lodash/bindAll'

export default class Nav {
  static run () {
    return new Nav()
  }

  constructor () {
    this.lib = window.lib
    this.$nav = $('.library-nav>.lvl-1')
    this.$navLi = $('.nav-lvl>li')
    this.$navLink = $('.js-nav-link')
    bindAll(this, ['animateHeight', 'animateHeightCallback'])

    this.setActiveState()
    this.$navLi.on('mouseover', this.animateHeight)
    this.$navLi.on('mouseout', this.animateHeightCallback)
    this.$navLink.on('click', () => {
      localStorage.setItem('seriesScrollTo', null)
      localStorage.setItem('scrollTo', null)
    })
  }

  animateHeight (e) {
    const t = e.currentTarget
    const $t = $(t)

    $t.addClass('hover')
    if (!$t.closest('.nav-lvl').hasClass('lvl-1') && $t.find('.nav-lvl').length) {
      const $ul = $t.closest('.nav-lvl')
      let $ulHeight = 0

      $ul.find('>li').each(function () {
        $ulHeight += $t.height()
      })
      const $bottom = $ul.offset().top + $ulHeight
      const $li = $t.find('>.nav-lvl>li')

      setTimeout(() => {
        $li.each(function () {
          if ($t.offset().top < $bottom && !$t.hasClass('with-border')) {
            $t.addClass('with-border')
          }
        })
      }, 200)
      const $subMenu = $t.find('>.nav-lvl')
      const $subMenuBottom = $subMenu[0].getBoundingClientRect().top + $subMenu.height()
      const $liHeight = $t.height()

      if ($subMenu.length && !$subMenu.hasClass('lvl-2') && ($subMenuBottom > window.innerHeight)) {
        $subMenu.eq(0).css('top', Math.floor((window.innerHeight - $subMenuBottom) / $liHeight) * $liHeight)
      }
    }

    let h = 0

    this.$nav.find('li.hover>.nav-lvl').each(function () {
      h = t.clientHeight > h ? t.clientHeight : h
    })
    this.$nav.find('.nav-lvl').css('min-height', h)
  }

  animateHeightCallback (e) {
    const t = e.currentTarget
    const $t = $(t)

    this.$nav.find('.nav-lvl').css('min-height', 0)
    $t.removeClass('hover').find('.hover').removeClass('hover')
    let h = 0

    this.$nav.find('li.hover>.nav-lvl').each(function () {
      h = t.clientHeight > h ? t.clientHeight : h
    })
    this.$nav.find('.nav-lvl').css('min-height', h)
  }

  setActiveState () {
    $('.navigation a').each(function () {
      const t = $(this)
      const location = window.location.href
      const link = this.href

      if (location.includes(link)) {
        const locationOrigin = window.location.origin
        const mainNavBtn = t.closest('.li-lvl-1').find('>.nav-btn')
        const mainNavBtnHref = mainNavBtn.href

        if (mainNavBtnHref === locationOrigin || mainNavBtnHref === `${locationOrigin}/` || mainNavBtnHref === `${locationOrigin}/#`) { return }

        mainNavBtn.addClass('active')
        t.closest('.lvl-2>li').find('>.nav-btn').addClass('active')
        t.closest('.lvl-3>li').find('>.nav-btn').addClass('active')
        t.addClass('active')
      }
    })
  }
}
